import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { Block } from '../index.js'
import { Expression } from '../../data/text-or-code.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

@jsonClass('ValidatorBlock')
export class ValidatorBlock extends Block {
	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Validation is tied to object',
		codeLanguage: 'ts',
		tsReturnType: () => 'object',
		editorSize: 'singleline',
		isBinding: false,
	})
	tiedToObjectExpression = new Expression('')
	constructor(init: Partial<ValidatorBlock> = {}) {
		super()
		this.validationRules = []
		this.init(init)
	}

	getEditorCategory(): string {
		return 'Additional Form Fields'
	}

	canHaveValidators() {
		return true
	}

	getValidationValueType(): string {
		return 'never'
	}
}
